<template>
  <div></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Query",
  data() {
    return {
      driver: Object,
    };
  },
  created() {
    const neo4j = require("neo4j-driver");
    const uri = "bolt://ecchr.metasphere.xyz:7687/";
    const user = "neo4j";
    const password = "burr-query-duel-cherry";
    const driver = neo4j.driver(uri, neo4j.auth.basic(user, password));
    this.driver = driver;
  },
  mounted() {
    this.runQuery();
    this.queryEntities();
  },
  computed: {
    ...mapState(["similarityObject"]),
    ...mapState(["entityObject"]),
  },
  methods: {
    async runQuery() {
      const query_image = `MATCH (a:Chunk)-[r:SIMILARITY]->(b:Chunk)
        RETURN a,b,r`;

      const session_image = this.driver.session();

      try {
        const result = await session_image.run(query_image, {
          collection_id: "f8487321ec78207ffa6a25f9fbff7079",
        });
        this.$store.commit("updateSimilarityObject", result);
      } finally {
        await session_image.close();
      }
    },
    async queryEntities() {
      const query_entities = `MATCH (c:Chunk)-[m:MENTIONS]->(e:Entity)
        WHERE NOT e.text = ""
        RETURN c,m,e`;

      const session_entities = this.driver.session();

      try {
        const result = await session_entities.run(query_entities, {
          collection_id: "f8487321ec78207ffa6a25f9fbff7079",
        });
        this.$store.commit("updateEntityObject", result);
      } finally {
        await session_entities.close();
      }
    },
  },
};
</script>

<style scoped>
button {
  background: black;
  border: 1px solid rgb(34, 34, 34);
  border-radius: 10px;
  padding: 8px 16px;
  color: white;
  margin-top: 15px;
}

button:hover {
  cursor: pointer;
  background-color: palevioletred;
  color: white;
}
</style>